<template>
	<!-- 活动-转盘活动-中奖记录 -->
	<div class="rotary-box">
		<!-- header头部 -->
		<header>
			<el-form :inline="true" class="demo-form-inline">
				<el-form-item>
					<el-input v-model.trim="query.user_id" placeholder="请输入用户id"></el-input>
				</el-form-item>
				<el-form-item>
					<el-input v-model.trim="query.name" placeholder="用户名称"></el-input>
				</el-form-item>
				<el-form-item label="时间段:">
					<el-date-picker v-model="query.start_time" type="datetime" placeholder="开始时间"
						value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
					-
					<el-date-picker v-model="query.end_time" type="datetime" placeholder="结束时间"
						value-format="yyyy-MM-dd HH:mm:ss">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getData(1)">搜索</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleExport">导出</el-button>
				</el-form-item>
			</el-form>
		</header>
		<!-- body内容 -->
		<div class="body-box">
			<el-table :data="dataList" v-loading="loading" style="margin-bottom: 20px">
				<el-table-column prop="user_id" label="用户id" align="center">
				</el-table-column>
				<el-table-column label="用户名称" align="center">
					<template slot-scope="{ row }">
						<span>{{ row.user && row.user.name }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="goods_name" label="物品名称" align="center">
				</el-table-column>
				<el-table-column prop="created_at" label="获取时间" align="center" sortable>
				</el-table-column>
			</el-table>

			<!-- 底部分页条 -->
			<el-pagination class="underBar" background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0"
				:current-page="dataMeta.current_page || 15" @current-change="handlePageChange"
				v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
		</div>

		<!-- 弹窗 -->
	</div>
</template>

<script>
	import {
		mapActions,
		mapMutations,
		mapState
	} from 'vuex'
	import http, {
		server,
		api,
		delApiData,
		getApiData,
		postApiData,
		patchApiData
	} from '@/http'
	import saveFile from '@/utils/saveFile'

	export default {
		name: 'vip_log',
		components: {},
		data() {
			return {
				dialogVisible: false, //弹窗显示标志
				loading: false, //加载动画
				buttonLoading: false, //按钮加载动画
				dialogLoading: false, //弹窗加载数据动画
				query: { //查询条件
					page: 1,
					user_id: undefined, //用户id
					name: undefined, //用户id
					start_time: undefined, //开始时间
					end_time: undefined, //结束时间
				},
				dialogInfo: undefined, //要传递的弹窗数据
				dataList: undefined, //列表数据
				dataMeta: undefined, //底部跳转页面条
			}
		},
		created() {
			this.getData()
		},
		methods: {
			getData(num) {
				if (num === 1) {
					this.query.page = 1
				}
				this.loading = true
				let params = this.query
				getApiData('records', params).then(res => {
					if (res) {
						this.dataList = res.data
						//设置底部导航条数据
						this.dataMeta = {
							current_page: res.current_page, //当前页标
							per_page: res.per_page, //每页多少条
							total: res.total, //总数据条数
							total_pages: res.total_pages, //总页数
						}
					}
				}).finally(() => {
					this.loading = false
				})
			},
			openConfigDialog() {
				//打开配置活动弹窗
			},
			handlePageChange(page) {
				//页面底部跳转页面
				this.query.page = page
				this.getData()
			},
			handleExport() {
				this.buttonLoading = true
        let params=this.query
				http
					.post(
						api + 'turntable_record_export',
            { ...params },
            {
							responseType: 'arraybuffer'
						}
					)
					.then(res => {
						saveFile(res, {
							type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
							name: '转盘中奖记录.xlsx'
						})
					}).finally(() => {
						this.buttonLoading = false
					})
			},
		},
	}

</script>

<style lang="less" scoped>
	.vip_log-box {
		header {}

		.body-box {}
	}

</style>
